module.exports = __webpack_public_path__ + "img/mo.53eca27e.svg";